function frete_produto() {
    
    var postalCode = $('.product-shipping #billing_cep').val();
    var productId = $('form .product-variant-id').val(); 
    var quantity = $('.product-form__quantity .quantity__input').val(); 
    
    console.log(`Quantidade: ${quantity}` ); 

    var originalCartItems = [];
    
    postalCode = postalCode.trim().replace('-', '');
    
    $('.product-shipping .results').hide();
    $('.product-shipping').addClass('waiting');
    
    if (postalCode === '') {
        $('.product-shipping .results').hide();
        $('.product-shipping').removeClass('waiting');
        return;
    }

    // ALTERAÇÃO 1: URL ajustada para o padrão BrasilAPI (sem o /json/ no final)
    $.ajax({
        url: `https://brasilapi.com.br/api/cep/v1/${postalCode}`,
        type: 'GET',
        dataType: 'json',
        success: function(data) {
            // A BrasilAPI não retorna "data.erro", ela retorna erro 404 se o CEP não existir
            // Mas para garantir a lógica do seu script:
            if (!data.state) {
                alert('CEP não encontrado. Por favor, tente novamente.');
                $('.product-shipping .results').hide();
                $('.product-shipping').removeClass('waiting');
                return;
            }

            // ALTERAÇÃO 2: A BrasilAPI usa "state" em vez de "uf"
            var state = data.state; 

            // Primeiro, obter o conteúdo atual do carrinho
            $.ajax({
                url: '/cart.js',
                type: 'GET',
                dataType: 'json',
                success: function(cartData) {
                    originalCartItems = cartData.items; 

                    // Limpar o carrinho
                    $.ajax({
                        url: '/cart/clear.js',
                        type: 'POST',
                        success: function() {
                            console.log('Carrinho limpo.');

                            // Adicionar o produto para o cálculo do frete
                            $.ajax({
                                url: '/cart/add.js',
                                type: 'POST',
                                dataType: 'json',
                                data: {
                                    id: productId,
                                    quantity: quantity
                                },
                                success: function() {
                                    // Após adicionar ao carrinho, calcular o frete
                                    $.ajax({
                                        url: '/cart/shipping_rates.json',
                                        type: 'GET',
                                        data: {
                                            'shipping_address[zip]': postalCode,
                                            'shipping_address[country]': 'BR',
                                            'shipping_address[province]': state // Agora com a sigla correta da BrasilAPI
                                        },
                                        success: function(data) {
                                            var rates = data.shipping_rates;
                                            var resultHtml = '';

                                            if (rates.length > 0) {
                                                $.each(rates, function(index, rate) {
                                                    resultHtml += '<p><span class="rate-name">' + rate.name + ':</span> R$ ' + rate.price + ' - <span class="rate-days">'+rate.delivery_days[0]+' dias úteis</span></p>';
                                                });
                                            } else {
                                                resultHtml = '<p>Não foi possível calcular o frete.</p>';
                                            }
        
                                            $('.product-shipping .results').html(resultHtml).slideDown();
                                            $('.product-shipping').removeClass('waiting');

                                            // Restaurar o carrinho original
                                            restaurarCarrinho(productId, originalCartItems);
                                        },
                                        error: function() {
                                            alert('Erro ao calcular o frete. Por favor, tente novamente.');
                                            $('.product-shipping').removeClass('waiting');
                                            restaurarCarrinho(productId, originalCartItems);
                                        }
                                    });
                                },
                                error: function() {
                                    alert('Erro ao adicionar o produto ao carrinho.');
                                    $('.product-shipping').removeClass('waiting');
                                }
                            });
                        }
                    });
                }
            });
        },
        error: function() {
            alert('CEP não encontrado ou serviço instável. Tente novamente.');
            $('.product-shipping .results').hide();
            $('.product-shipping').removeClass('waiting');
        }
    });
}

// Função auxiliar para restaurar o carrinho e evitar repetição de código
function restaurarCarrinho(productId, items) {
    $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        data: { id: productId, quantity: 0 },
        success: function() {
            if (items.length > 0) {
                items.forEach(function(item) {
                    $.ajax({
                        url: '/cart/add.js',
                        type: 'POST',
                        data: { id: item.id, quantity: item.quantity }
                    });
                });
            }
        }
    });
}